<template>
  <nav class="panel">
    <p class="panel-tabs is-size-6">
        <a @click="$router.push('/wallet/buy')" :class="{ 'is-active': isActive('/wallet/buy') }">
            <span class="icon"><i class="fa fa-money"></i></span>
            <span>{{ $t("Buy") }}</span>
        </a>
        <a @click="$router.push('/wallet/send')" :class="{ 'is-active': isActive('/wallet/send') }">
            <span class="icon"><i class="fa fa-exchange"></i></span>
            <span>{{ $t("Send") }}</span>
        </a>
        <a @click="$router.push('/wallet/transactions')" :class="{ 'is-active': isActive('/wallet/transactions') }">
            <span class="icon"><i class="fa fa-history"></i></span>
            <span>{{ $t("Transactions") }}</span>
        </a>
    </p>
  </nav>
</template>

<script>
export default {
  name: "WalletTabs"
};
</script>